import { getTimeSinceUTCDate } from "./timestamp";


let NOTIFICATION_ITEM_CLASS = "notification-item";


function ajax_notify_update(ids_to_update, attr, attrvalue, success_callback, error_callback=null) {
    let url = urls.get('ajax_notify_update');
    let payload = {"messages": ids_to_update};
    payload[attr] = attrvalue;
    $.ajax({
        url: url,
        method: "POST",
        type: "POST",
        timeout: 10000,
        data: payload,
        // The following options broke this method altogether.
        //data: JSON.stringify(payload),
        //processData: false,
        //contentType: false,
        success: success_callback,
        error: function(jqXHR, textStatus, errorThrown) {
            window.console.log("Error while posting to " + url + ": textStatus="
                + textStatus + " errorThrown=" + errorThrown);
            if (error_callback) {
                error_callback();
            }
        }
    });
}

function _mapunion(map0, map1) {
    let m = {}, map=null, key=null;
    for (map of [map0, map1]) {
        for (key in map) {
            m[key] = map[key];
        }
    }
    return m;
}

class Notification extends Backbone.Model {

    get idAttribute () {
        return "created";
    }

    destroy () {
        let id_to_delete = this.get("created");
        let that = this;
        ajax_notify_update(id_to_delete, "delete", true, function(data, textStatus, jqXHR) {
            that.trigger("notification:hide", id_to_delete);
        });
    }

    get created_as_date () {
        const CREATED_REGEX = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.(\d{3})/;
        let match = CREATED_REGEX.exec(this.get("created"));
        let d = new XDate();
        if (match) {
            d.setUTCFullYear(match[1], parseInt(match[2], 10) - 1, match[3]);
            d.setUTCHours(match[4], match[5], match[6], match[7]);
        }
        return d;
    }
}

class Notifications extends Backbone.Collection {

    markAllAs (attr) {
        let ids_to_update = this.get_not_attr(attr);
        let that = this;
        ajax_notify_update(ids_to_update.toString(), attr, true, function(data, textStatus, jqXHR){
            for (let id of ids_to_update) {
                that.get(id).set(attr, true);
            }
        });
    }

    get model () {
        return Notification;
    }

    get url () {
        return urls.get('ajax_notify_items');
    }

    get unviewed () {
        return this.count_not_attr('viewed', '');
    }

    get unread () {
        return this.count_not_attr('read', '');
    }

    parse (response) {
        return response.notifications;
    }

    /*
    count_not_attr('viewed', '') returns 5 if there are 5 unviewed messages,
    or an empty string if there are 0 unviewed messages.
    */
    count_not_attr (attr, zerovalue) {
        let count = this.get_not_attr(attr).length;
        return count ? count : zerovalue;
    }

    // get_not_attr('viewed') returns the ID's (i.e., unique creation timestamps) of unviewed messages
    get_not_attr (attr) {
        let ids = [];
        this.reduce(function(idarray, n){
            if (!n.get(attr)) {
                idarray.push(n.get("created"));
            }
            return idarray;
        }, ids);
        return ids;
    }
}

class NotificationsBadgeView extends Backbone.View {

    initialize () {
        for (let event of ['change', 'remove', 'sync']) {
            this.listenTo(this.model, event, this.render);
        }
        this.template = _.template('<%= unviewed %>')
    }

    render () {
        this.$el.html(this.template(this.model));
        if (this.model.unviewed) {
            this.$el.parent().addClass("badged");
        }
        else {
            this.$el.parent().removeClass("badged");
        }
        return this;
    }
}

class NotificationView extends Backbone.View {

    _avatar() {
        let m = this.model;
        let avatar_element = m.get("re_user_initials");
        let re_user_image_url = m.get("re_user_image_url");
        let re_user_avatar_disk = m.get("re_user_avatar_disk");
        if (re_user_image_url) {
            avatar_element = `<img class="profile-image" src="${re_user_image_url}"/>`;
        }
        return `<div class="photo"><div class="avatar avatar-${re_user_avatar_disk} small">${avatar_element}</div></div>`;
    }

    _event_settings_link() {
        var m = this.model;
        if (!m.get("event_settings_url")) {
            return "";
        }
        return `<a class="ui-link" href="${m.get("event_settings_url")}">Adjust Notification settings for this event</a>`;
    }

    _rendercontext() {
        let timestamp = getTimeSinceUTCDate(this.model.created_as_date);
        let read_bullet = "●";
        let switch_read_state = "read";
        if (this.model.get("read")) {
            read_bullet = "○";
            switch_read_state = "unread";
        }
        var extra = {
            "avatar": this._avatar(),
            "event_settings_link": this._event_settings_link(),
            "read_bullet": read_bullet,
            "switch_read_state": switch_read_state,
            "timestamp": timestamp
        };
        return _mapunion(this.model.attributes, extra);
    }

    get template() {
        let template_text = this.parent_view.notification_template;
        return _.template(template_text);
    }

    get events() {
        let evmap = {
            'click .hide-notification': 'hideNotification',
            'click .bullet-with-tooltip': 'toggleRead',
            'mouseenter .notification-item': 'showContextControls',
            'mouseleave .notification-item': 'hideContextControls'
        };

        // Special handling for IE11
        if (this.is_ie11()) {
            evmap['click .context-menu-icon'] = 'selectContextMenuOnIE11';
            evmap['blur .notification-context-menu'] = 'handleNotificationContextMenuBlurOnIE11';
        }
        else {
            evmap['click .context-menu-icon'] = 'selectContextMenu';
            evmap['click .notification-text'] = 'setNotificationAsReadThenNavigate';
            evmap['focusout .notification-context-menu'] = 'hideContextMenu';
        }
        return evmap;
    }

    initialize(options) {
        this.options = options;
        this.parent_view = this.options.parent_view;
        this.listenTo(this.model, "change", this.render);
        this.context_controls_should_be_visible = false;
        this.discard_ie11_blurs = false;
    }

    render () {
        let context = this._rendercontext();
        let html = this.template(context);
        this.$el.html(html);
        if (this.model.get("read")) {
            let element = this.$el.find('.' + NOTIFICATION_ITEM_CLASS);
            element.addClass('was-read');
        }
        if (this.context_controls_should_be_visible) {
            this.showContextControls();
        }
        return this;
    }

    selectContextMenuOnIE11(event) {
        // console.log('selectContextMenuOnIE11()');
        // console.log(event);
        this.selectContextMenu(event);
    }

    is_ie11() {
        try {
            return $.browser.mozilla && $.browser.version == "11.0";
        }
        catch(TypeError) {
            return false;
        }
    }

    handleNotificationContextMenuBlurOnIE11(event) {
        // console.log('handleNotificationContextMenuBlurOnIE11()');
        // console.log(event);
        if (event.target.className == "context-menu-icon") {
            // console.log('The blur happened for ' + tclass + '. Discarding.');
            return;
        }
        if (event.target.className == "hide-notification ui-link") {
            // console.log('Blur on the hide notification link means it was clicked.  Triggering...');
            this.hideNotification("Manual trigger");
        }
        if (event.target.className == 'ui-link') {
            // console.log('Blur on the event settings link means it was clicked. Triggering ' + event.target.href);
            this.discard_ie11_blurs = true;  // We're going to a new page. Forget about doing more here.
            this.setNotificationAsReadThenNavigate(event);
        }
        if (this.discard_ie11_blurs) {
            // console.log("this.discard_ie11_blurs is true. Discarding the blur.");
            return;
        }
        // console.log('The blur happened for ' + event.target.className);
        this.hideContextMenu();
    }

    setNotificationAsReadThenNavigate(event) {
        let linkurl = this.$el.find('.notification-text').attr('href');
        let follow_link = function(){
            window.location.assign(linkurl);
        }
        if (!this.model.get('read')) {
            this.toggleRead(follow_link);
        }
        else {
            follow_link();
        }
        if (event) {
            event.stopImmediatePropagation();
        }
    }

    toggleRead(callback=null) {
        let read_new = !this.model.get('read');
        let that = this;
        ajax_notify_update(this.model.get('created'), 'read', read_new, function() {
            that.model.set('read', read_new);
            if (callback) {
                callback();
            }
        }, callback)
    }

    hideNotification(event) {
        // console.log("hideNotification()");
        // console.log(event);
        this.model.destroy();
    }

    selectContextMenu(event) {
        this.$el.find('.context-menu-items-wrapper').css('display', 'block');
        this.$el.find('.notification-context-menu').focus();
    }

    hideContextMenu() {
        this.$el.find('.context-menu-items-wrapper').css('display', 'none');
    }

    showContextControls() {
        for (let cselect of ['.bullet-with-tooltip', '.notification-context-menu']) {
            this.$el.find(cselect).css('visibility', 'visible');
        }
        this.context_controls_should_be_visible = true;
    }

    hideContextControls() {
        this.hideContextMenu();
        for (let cselect of ['.bullet-with-tooltip', '.notification-context-menu']) {
            this.$el.find(cselect).css('visibility', 'hidden');
        }
        this.context_controls_should_be_visible = false;
    }
}

class SponsoredNotificationView extends Backbone.View {

    initialize(options) {
        this.options = options;
        this.parent_view = this.options.parent_view;
        this.listenTo(this.model, "change", this.render);
    }

    get template() {
        let template_text = this.parent_view.sponsored_notification_template;
        return _.template(template_text);
    }

    render () {
        let html = this.template(this.model.attributes);
        this.$el.html(html);
        return this;
    }

}
class NotificationCenterView extends Backbone.View {

    get events() {
        return {
            "click .notifications-mark-all-as-read": "markAllAsRead",
        };
    };

    handle_click() {
        if (this.options.nav_support) {
            let listelem = $(this.el).find('.notifications-list');
            let newvalue = listelem.css('display') == 'none' ? 'block' : 'none';
            listelem.css('display', newvalue);
        }
    }

    list_element_source(selector) {
        let element = this.$el.find(selector)[0];
        let template_raw = element.innerHTML;
        // unquote expressions
        let template = template_raw.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        // If the element is wrapped in a script, just strip that outer element away and return it.
        if (element.localName == 'script') {
            return template;
        }
        // Don't show the element if it is empty.
        let className = element.className;
        if (!template) {
            className = 'do-not-show';
        }
        return '<' + element.localName + ' class="' + className + '">' + template + '</' + element.localName +'>';
    }

    initialize(options) {
        this.options = options;
        for (let event of ['remove', 'sync']) {
            this.listenTo(this.model, event, this.render);
            this.listenTo(this.model, event, this.enable_or_disable_pulldown);
        }
        // If this is the view to show all notifications, reset the "viewed" state for all.
        if (this.options.viewing_all_notifications) {
            this.listenTo(this.model, 'sync', this.markAllAsViewed);
        }

        // Cache this element from the template for use later
        this.notifications_list_header = this.list_element_source('.notifications-list-header');
        this.notifications_list_footer = this.list_element_source('.notifications-list-footer');
        this.notification_template = this.list_element_source('.notification-item-wrapper');
        this.sponsored_notification_template = this.list_element_source('.sponsored-notification-item-wrapper');
        this.empty_notification_items_list = this.list_element_source('.empty-notification-items-list');
        this.page_size = this.options.items_per_page;
        this.page_index = 0;

        if (this.options.pulldown) {
            let that = this;
            this.options.pulldown.addPulldownClickCallback(function() {
                that.markAllAsViewed();
            });
        }
    }

    notify_element_id (i) {
        let prefix = this.$el.attr("id");
        return `${prefix}_notify_item_${i}`;
    }

    enable_or_disable_pulldown() {
        if (this.options.pulldown) {
            // If we ever remove the "no notifications" default message in the Notification Center,
            // turn this back on.
            //this.options.pulldown.setEnabled(this.model.length > 0);
        }
    }

    render() {
        let list_element = this.$el.find('.notifications-list');
        let tagName = "li";

        // Create empty list items, one for each notification.
        list_element.html(this.notifications_list_header + this.notifications_list_footer);
        let starting_index = this.page_size * this.page_index;
        let ending_index = Math.min(this.model.length, this.page_size * (1 + this.page_index));
        for (var i = starting_index; i < ending_index; ++i) {
            let item = `<${tagName} id="${this.notify_element_id(i)}"></${tagName}>`;
            this.$el.find('.notifications-list>li:last-child').before(item);
        }

        // Create a view for each Notification.
        let has_sponsored = false;
        for (var i = starting_index; i < ending_index; ++i) {
            let model = this.model.at(i);
            let el = this.$el.find(`${tagName}#${this.notify_element_id(i)}`);
            let view_options = {
                el: el,
                model: model,
                id: this.notify_element_id(),
                parent_view: this
            };
            if (model.get("msg_type") == "sponsored") {
                model.view = new SponsoredNotificationView(view_options);
                has_sponsored = true;
            }
            else {
                model.view = new NotificationView(view_options);
            }
            model.trigger("change");
            this.listenTo(model, "notification:hide", this.hideNotification);
        }

        if (ending_index == 0 || (has_sponsored && ending_index == 1)) {
            let item = this.empty_notification_items_list;
            this.$el.find('.notifications-list>li:last-child').before(item);
        }

        return this;
    }

    markAllAsViewed() {
        if (this.model.unviewed > 0) {
            this.model.markAllAs("viewed");
        }
    }

    markAllAsRead() {
        this.model.markAllAs("read");
    }

    hideNotification(created) {
        this.model.remove(created);
    }
}

class PulldownMenu extends Backbone.View {

    get events() {
        return {
            "click a.pulldown-link": "onPulldownClick",
            "focusout": "handleFocusout",
            "mouseenter": "handleMouseenter",
            "mouseleave": "handleMouseleave",
        };
    }

    initialize(options) {
        this.options = options;
        this.hide_class = 'notifications-list-ornament-hidden';
        this.mouse_is_overhead = false;
        this.enabled = true;
        this.pulldown_click_callback = null;
    }

    get menu() {
        return this.$el.find('ul.menu');
    }

    get ornament() {
        return this.$el.find('.notifications-list-ornament');
    }

    menuIsHidden() {
        return this.ornament.hasClass(this.hide_class);
    }

    hideMenu() {
        this.ornament.addClass(this.hide_class);
        this.menu.css('display', 'none');
    }

    showMenu() {
        if (this.enabled) {
            this.ornament.removeClass(this.hide_class);
            this.menu.css('display', 'block');
        }
    }

    addPulldownClickCallback(callback) {
        this.pulldown_click_callback = callback;
    }

    onPulldownClick() {
        this.toggleMenu();
        if (this.pulldown_click_callback) {
            this.pulldown_click_callback();
        }
    }

    toggleMenu() {
        if (this.menuIsHidden()) {
            this.showMenu();
        }
        else {
            this.hideMenu();
        }
    }

    handleFocusout(event) {
        //console.log(event);
        if (!this.mouse_is_overhead) {
            //console.log("Hide menu after focusout:");
            this.hideMenu();
        }
    }

    handleMouseenter(event) {
        if (!this.mouse_is_overhead) {
            //console.log("On mouseenter, mouse_is_overhead is switching to true.");
        }
        this.mouse_is_overhead = true;
    }

    handleMouseleave(event) {
        if (this.mouse_is_overhead) {
            //console.log("On mouseleave, mouse_is_overhead is switching to false.");
        }
        this.mouse_is_overhead = false;
        this.$el.find('a.pulldown-link').focus();
    }

    setEnabled(e) {
        this.enabled = e;
        if (!e) {
            this.hideMenu();
        }
    }
}

$(document).ready(function() {
    // none of this applies if the user is not logged in, let's save ourselves some browser time
    if(!window.client_data.is_logged_in)
        return;

    let notifications = new Notifications();
    let viewing_all_notifications = false;
    let nav_support = true;
    let nav_center_pulldown = null;

    $('.unviewed-count').each(function() {
        new NotificationsBadgeView({
            el: this,
            model: notifications
        });
    });

    $('li.account-more').each(function() {
        let pulldown = new PulldownMenu({
            el: this
        });
        if (this.id == "nav_nctr") {
            nav_center_pulldown = pulldown;
        }
    });

    $('.notification-center').each(function() {
        let items_per_page = window.NOTIFICATION_CENTER_NAVBAR_LIMIT; // nav bar view
        let pulldown = null;
        if (this.id == "nav_nctr") {
            pulldown = nav_center_pulldown;
        }
        else {
            viewing_all_notifications = true;
            nav_support = false;
            items_per_page = window.NOTIFICATION_CENTER_PER_USER_LIMIT;
        }
        if (items_per_page > 0) {
            let notification_center_view = new NotificationCenterView({
                el: this,
                model: notifications,
                items_per_page: items_per_page,
                pulldown: pulldown,
                nav_support: nav_support,
                viewing_all_notifications: viewing_all_notifications,
            });
        }
    });

    notifications.fetch();
});



// WEBPACK FOOTER //
// ./assets/es6/common/notify.es6